<template>

  <modalo
    :title="$t('Share')"
    type="small"
    @hideModal="hideModal()">

    <form
      id="share-candidate-form"
      v-on:submit.prevent="saveShare(share)">

      <div
        v-if="share._id"
        class="alert alert-primary">
        <a
          :href="share.url"
          target="_blank">
          <i class="fas fa-external-link-alt" />
          {{ $t('Preview') }}
        </a>
      </div>

      <div class="form-group">
        <label class="control-label">* {{ $t('Candidates') }}</label>
        <SelectMultipleCandidates
          v-model="share.candidates" />
      </div>
      <div class="form-group">
        <label class="control-label">* {{ $t('Expires in') }}</label>
        <date 
          :setting="{format: 'DD-MM-YYYY'}"
          v-model="share.expired_at">
          </date>
        <ValidateMessage :error="validateErrors.expired_at" />
      </div>
      <div class="form-group">
        <label for="exampleFormControlInput1">{{ $t('Show') }}</label>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="share.permissions.contact">
          <label class="form-check-label">
            Informações de contato
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="share.permissions.salary">
          <label class="form-check-label">
            {{ $t('Salary') }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="share.permissions.resume">
          <label class="form-check-label">
            {{ $t('Resume (file)') }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="share.permissions.evaluations">
          <label class="form-check-label">
            {{ $t('Evaluations') }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="share.permissions.intervideos">
          <label class="form-check-label">
            {{ $t('Video interview') }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="share.permissions.questionnaires">
          <label class="form-check-label">
            {{ $t('Questionnaires') }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="share.permissions.candidate_attachs">
          <label class="form-check-label">
            {{ $t('Attachs') }}
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="share.permissions.add_evaluation">
          <label class="form-check-label">
            {{ $t('Allow evaluation') }}
          </label>
        </div>
      </div>

      <div  v-if="!share._id">
        <hr>

        <div
          class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="share.send_email">
          <label class="form-check-label">
            {{ $t('Send email') }}
          </label>
        </div>
        
        <div v-if="share.send_email">
          <div class="mb-2">
            <SelectizeEmail v-model="share.to" />
            <ValidateMessage :error="validateErrors.to" />
          </div>
          <div>
            <textarea-autosize
              :placeholder="$t('Message')"
              v-model="share.body"
              class="form-control"></textarea-autosize>
            <ValidateMessage :error="validateErrors.body" />
          </div>
        </div>

      </div>
      
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="share-candidate-form"
          class="btn btn-primary">{{ $t('Share') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click.stop="hideModal()">{{ $t('Cancel') }}</button>
        <button
          v-if="share._id"
          type="button"
          class="btn btn-danger"
          @click="deleteShare(share._id)">{{ $t('Delete') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import SelectizeEmail from '@/components/Fields/SelectizeEmail'
import SelectMultipleCandidates from '@/components/Fields/SelectMultipleCandidates'
import Date from '@/components/Fields/Date'
import moment from 'moment'

export default {
  name: 'MassiveShareCandidate',
  components: {
    SelectizeEmail,
    Date,
    SelectMultipleCandidates
  },
  props: [
    'initShare'
  ],
  data () {
    return {
      loading: false,
      share: this.defaultValues(this.initShare),
      validateErrors: {}
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        expired_at: moment().add(1, 'month').startOf('day').toISOString(),
        permissions: {
          evaluations: true
        }
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveShare
    */
    saveShare (data) {
      if (data._id) this.updateShare(data)
      else this.createShare(data)
    },
    /*
    createShare
    */
    createShare (data) {
      this.loading = true

      this.$store
      .dispatch('createShareCandidate', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateShare
    */
    updateShare (data) {
      this.loading = true

      this.$store
      .dispatch('updateShareCandidate', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteShare (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteShareCandidate', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MassiveShareCandidate/MassiveShareCandidate.vue